let GAMES = {
  puzzle: {
    title: 'Собери мир по кусочкам!',
    text: 'В детстве у каждого из нас были мозаики, и мы могли провести за их сбором весь день. Здесь же надо собрать континенты из стран и страны из регионов. По каждому из них есть краткое описание и ссылка на Wikipedia, чтобы узнать этот кусочек огромного мира получше.',
    sections: [{
      title: 'Мир',
      items: [
        {slug: 'world', title: 'Сложный', center: [-40.34, 26.01], zoom: 3, difficult: 'medium'},
        {slug: 'easy', title: 'Лёгкий', center: [3.86, 37.52], zoom: 4, difficult: 'easy'},
      ]
    }, {
      title: 'Континенты',
      items: [
        {slug: 'europe', title: 'Европа', center: [13.00, 48.51], zoom: 4, difficult: 'easy'},
        {slug: 'asia', title: 'Азия', center: [73.12, 32.34], zoom: 4, difficult: 'easy'},
        {slug: 'america', title: 'Америка', center: [-62.57, -17.57], zoom: 4, difficult: 'easy'},
        {slug: 'africa', title: 'Африка', center: [13.00, 3.51], zoom: 4, difficult: 'medium'},
        {slug: 'eu', title: 'Евросоюз', center: [9.77, 56.21], zoom: 4, difficult: 'easy'},
        {slug: 'commonwealth', title: 'Содружество наций', center: [32.87, 15.45], zoom: 4, difficult: 'medium'},
        {slug: 'ussr', title: 'СССР', center: [56.57, 49.77], zoom: 5, difficult: 'easy'},
        {slug: 'british_empire', title: 'Британская империя', center: [50.82, -1.42], zoom: 5, difficult: 'medium'},
        {slug: 'portugal_colony', title: 'Колонии Португалии', center: [-7.88, -26.69], zoom: 5, difficult: 'medium'},
        {slug: 'french_empire', title: 'Французская империя', center: [20.37, 11.00], zoom: 5, difficult: 'medium'},
      ]
    }, {
      title: 'Страны',
      items: [
        {slug: 'russia', title: 'Россия', center: [85.78, 60.82], zoom: 4, difficult: 'medium'},
        {slug: 'usa', title: 'США', center: [-109.68, 34.80], zoom: 4, difficult: 'medium'},
        {slug: 'australia', title: 'Австралия', center: [134.27, -25.17], zoom: 5, difficult: 'easy'},
        {slug: 'austria', title: 'Австрия', center: [14.46, 47.46], zoom: 7, difficult: 'medium'},
        {slug: 'argentina', title: 'Аргентина', center: [-60.18, -39.98], zoom: 5, difficult: 'medium'},
        {slug: 'armenia', title: 'Армения', center: [44.94, 40.10], zoom: 8, difficult: 'easy'},
        {slug: 'belarus', title: 'Беларусь', center: [27.94, 53.59], zoom: 6, difficult: 'easy'},
        {slug: 'brazil', title: 'Бразилия', center: [-53.08, -10.48], zoom: 5, difficult: 'medium'},
        {slug: 'uk', title: 'Великобритания', center: [-3.36, 55.44], zoom: 6, difficult: 'hard'},
        {slug: 'hungary', title: 'Венгрия', center: [19.94, 47.02], zoom: 7, difficult: 'medium'},
        {slug: 'germany', title: 'Германия', center: [10.01, 51.54], zoom: 6, difficult: 'easy'},
        {slug: 'greece', title: 'Греция', center: [24.47, 38.18], zoom: 7, difficult: 'medium'},
        {slug: 'georgia', title: 'Грузия', center: [41.95, 43.70], zoom: 7, difficult: 'medium'},
        {slug: 'denmark', title: 'Дания', center: [9.77, 56.21], zoom: 7, difficult: 'easy'},
        {slug: 'india', title: 'Индия', center: [81.21, 23.55], zoom: 5, difficult: 'medium'},
        {slug: 'indonesia', title: 'Индонезия', center: [119.06, 0.49], zoom: 5, difficult: 'hard'},
        {slug: 'ireland', title: 'Ирландия', center: [-8.32, 53.30], zoom: 7, difficult: 'hard'},
        {slug: 'spain', title: 'Испания', center: [-4.94, 38.67], zoom: 6, difficult: 'easy'},
        {slug: 'italy', title: 'Италия', center: [11.35, 39.96], zoom: 6, difficult: 'easy'},
        {slug: 'kazakhstan', title: 'Казахстан', center: [66.70, 48.69], zoom: 5, difficult: 'easy'},
        {slug: 'kyrgyzstan', title: 'Киргизия', center: [74.56, 41.65], zoom: 6, difficult: 'medium'},
        {slug: 'china', title: 'Китай', center: [101.66, 31.86], zoom: 5, difficult: 'hard'},
        {slug: 'lithuania', title: 'Литва', center: [24.03, 55.08], zoom: 7, difficult: 'easy'},
        {slug: 'mexico', title: 'Мексика', center: [-103.53, 22.14], zoom: 5, difficult: 'medium'},
        {slug: 'netherlands', title: 'Нидерланды', center: [5.25, 52.26], zoom: 7, difficult: 'medium'},
        {slug: 'new_zealand', title: 'Новая Зеландия', center: [171.03, -40.91], zoom: 6, difficult: 'easy'},
        {slug: 'poland', title: 'Польша', center: [18.91, 52.48], zoom: 6, difficult: 'easy'},
        {slug: 'romania', title: 'Румыния', center: [24.87, 45.61], zoom: 7, difficult: 'hard'},
        {slug: 'syria', title: 'Сирия', center: [37.30, 35.44], zoom: 7, difficult: 'easy'},
        {slug: 'tajikistan', title: 'Таджикистан', center: [70.86, 38.88], zoom: 5, difficult: 'easy'},
        {slug: 'turkmenistan', title: 'Туркменистан', center: [59.27, 39.48], zoom: 5, difficult: 'easy'},
        {slug: 'turkey', title: 'Турция', center: [35.62, 35.76], zoom: 6, difficult: 'hard'},
        {slug: 'uzbekistan', title: 'Узбекистан', center: [41.61, 63.01], zoom: 5, difficult: 'medium'},
        {slug: 'ukraine', title: 'Украина', center: [30.83, 49.56], zoom: 5, difficult: 'medium'},
        {slug: 'philippines', title: 'Филиппины', center: [118.72, 11.06], zoom: 5, difficult: 'hard'},
        {slug: 'france', title: 'Франция', center: [2.54, 46.67], zoom: 6, difficult: 'easy'},
        {slug: 'switzerland', title: 'Швейцария', center: [8.37, 46.81], zoom: 7, difficult: 'hard'},
        {slug: 'sweden', title: 'Швеция', center: [18.81, 63.15], zoom: 5, difficult: 'medium'},
        {slug: 'estonia', title: 'Эстония', center: [25.96, 58.58], zoom: 7, difficult: 'easy'},
        {slug: 'japan', title: 'Япония', center: [139.48, 36.65], zoom: 6, difficult: 'hard'},
      ]
    }, {
      title: 'Регионы России',
      items: [
        {slug: '7tvc312oa3p2', title: 'Амурская область', center: [127.49, 52.65], zoom: 5, difficult: 'hard'},
        {slug: '8sgfj62wspec', title: 'Архангельская область', center: [47.29, 68.47], zoom: 4, difficult: 'hard'},
        {slug: '849sqcypmt9e', title: 'Забайкальский край', center: [115.04, 54.95], zoom: 5, difficult: 'hard'},
        {slug: '4fiek6ibgdma', title: 'Иркутская область', center: [107.51, 58.17], zoom: 5, difficult: 'hard'},
        {slug: 'pk3bmb07h0wc', title: 'Калининградская область', center: [21.23, 54.88], zoom: 8, difficult: 'medium'},
        {slug: 'jswf2fzybznq', title: 'Карелия республика', center: [33.11, 63.79], zoom: 6, difficult: 'medium'},
        {slug: 'px6yem7sx6xe5li', title: 'Краснодарский край', center: [39.35, 44.99], zoom: 7, difficult: 'hard'},
        {slug: 'sjsphum6v17y', title: 'Ленинградская область', center: [30.53, 60.44], zoom: 6, difficult: 'medium'},
        {slug: '73gb7gmffvgo', title: 'Москва и Московская область', center: [37.69, 55.60], zoom: 7, difficult: 'hard'},
        {slug: 'togikdria3qk', title: 'Приморский край', center: [132.77, 44.71], zoom: 6, difficult: 'hard'},
        {slug: 'dgkjq1jzv9uv', title: 'Ставропольский край', center: [43.07, 44.47], zoom: 7, difficult: 'hard'},
        {slug: 'u82n9u765j2p', title: 'Хабаровский край', center: [136.82, 55.16], zoom: 5, difficult: 'medium'},
      ]
    }]
  },
  quiz: {
    title: 'Найди на карте!',
    text: 'В игре «Викторина» искать страну нужно будет по флагу, гербу или столице. Знали ли вы, что у Монако и Индонезии одинаковые флаги? А что флаги США и Либерии отличаются только количеством звёзд? Так вот, эти и другие интересности можно узнать и запомнить, пройдя мозговой штурм прямо сейчас!',
    sections: [{
      title: 'Мир',
      items: [
        {slug: 'world', title: 'Сложный', center: [-40.34, 26.01], zoom: 3, difficult: 'medium'},
        {slug: 'easy', title: 'Лёгкий', center: [3.86, 37.52], zoom: 4, difficult: 'easy'},
      ]
    }, {
      title: 'Континенты',
      items: [
        {slug: 'europe', title: 'Европа', center: [13.00, 48.51], zoom: 4, difficult: 'easy'},
        {slug: 'asia', title: 'Азия', center: [73.12, 32.34], zoom: 4, difficult: 'medium'},
        {slug: 'america', title: 'Америка', center: [-62.57, -17.57], zoom: 4, difficult: 'easy'},
        {slug: 'africa', title: 'Африка', center: [13.00, 3.51], zoom: 4, difficult: 'medium'},
        {slug: 'eu', title: 'Евросоюз', center: [9.77, 56.21], zoom: 4, difficult: 'easy'},
        {slug: 'commonwealth', title: 'Содружество наций', center: [32.87, 15.45], zoom: 4, difficult: 'medium'},
        {slug: 'ussr', title: 'СССР', center: [56.57, 49.77], zoom: 5, difficult: 'easy'},
      ]
    }, {
      title: 'Страны',
      items: [
        {slug: 'russia', title: 'Россия', center: [85.78, 60.82], zoom: 4, difficult: 'medium'},
        {slug: 'usa', title: 'США', center: [-109.68, 34.80], zoom: 4, difficult: 'medium'},
        {slug: 'australia', title: 'Австралия', center: [134.27, -25.17], zoom: 5, difficult: 'easy'},
        {slug: 'austria', title: 'Австрия', center: [14.46, 47.46], zoom: 7, difficult: 'medium'},
        {slug: 'argentina', title: 'Аргентина', center: [-60.18, -39.98], zoom: 5, difficult: 'medium'},
        {slug: 'armenia', title: 'Армения', center: [44.94, 40.10], zoom: 8, difficult: 'medium'},
        {slug: 'belarus', title: 'Беларусь', center: [27.94, 53.59], zoom: 6, difficult: 'easy'},
        {slug: 'brazil', title: 'Бразилия', center: [-53.08, -10.48], zoom: 5, difficult: 'medium'},
        {slug: 'uk', title: 'Великобритания', center: [-3.36, 55.44], zoom: 6, difficult: 'hard'},
        {slug: 'hungary', title: 'Венгрия', center: [19.94, 47.02], zoom: 7, difficult: 'medium'},
        {slug: 'germany', title: 'Германия', center: [10.01, 51.54], zoom: 6, difficult: 'easy'},
        {slug: 'greece', title: 'Греция', center: [24.47, 38.18], zoom: 7, difficult: 'medium'},
        {slug: 'denmark', title: 'Дания', center: [9.77, 56.21], zoom: 7, difficult: 'easy'},
        {slug: 'india', title: 'Индия', center: [81.21, 23.55], zoom: 5, difficult: 'medium'},
        {slug: 'indonesia', title: 'Индонезия', center: [119.06, 0.49], zoom: 5, difficult: 'hard'},
        {slug: 'ireland', title: 'Ирландия', center: [-8.32, 53.30], zoom: 7, difficult: 'hard'},
        {slug: 'spain', title: 'Испания', center: [-4.94, 38.67], zoom: 6, difficult: 'medium'},
        {slug: 'italy', title: 'Италия', center: [11.35, 39.96], zoom: 6, difficult: 'medium'},
        {slug: 'kazakhstan', title: 'Казахстан', center: [66.70, 48.69], zoom: 5, difficult: 'medium'},
        {slug: 'china', title: 'Китай', center: [101.66, 31.86], zoom: 5, difficult: 'hard'},
        {slug: 'lithuania', title: 'Литва', center: [24.03, 55.08], zoom: 8, difficult: 'medium'},
        {slug: 'mexico', title: 'Мексика', center: [-103.53, 22.14], zoom: 5, difficult: 'medium'},
        {slug: 'netherlands', title: 'Нидерланды', center: [5.25, 52.26], zoom: 7, difficult: 'easy'},
        {slug: 'new_zealand', title: 'Новая Зеландия', center: [171.03, -40.91], zoom: 6, difficult: 'medium'},
        {slug: 'poland', title: 'Польша', center: [18.91, 52.48], zoom: 6, difficult: 'medium'},
        {slug: 'romania', title: 'Румыния', center: [24.87, 45.61], zoom: 7, difficult: 'hard'},
        {slug: 'syria', title: 'Сирия', center: [37.30, 35.44], zoom: 7, difficult: 'medium'},
        {slug: 'turkey', title: 'Турция', center: [35.62, 35.76], zoom: 5, difficult: 'hard'},
        {slug: 'philippines', title: 'Филиппины', center: [118.72, 11.06], zoom: 5, difficult: 'hard'},
        {slug: 'switzerland', title: 'Швейцария', center: [8.37, 46.81], zoom: 7, difficult: 'hard'},
        {slug: 'sweden', title: 'Швеция', center: [18.81, 63.15], zoom: 5, difficult: 'medium'},
        {slug: 'estonia', title: 'Эстония', center: [25.96, 58.58], zoom: 7, difficult: 'medium'},
        {slug: 'japan', title: 'Япония', center: [139.48, 36.65], zoom: 6, difficult: 'hard'},
      ]
    }]
  },
  city: {
    title: 'Города',
    text: 'В игре "Города" вам надо найти все города по их названию. Вы знали, что в мире 11 Парижей, причём 9 из них находятся в США?! А городов-миллионников всего 365 - сможете найти их все?',
    sections: [{
      title: 'Мир',
      items: [
        {slug: 'famous', title: 'Известные города', center: [-40.34, 26.01], zoom: 3, difficult: 'easy'},
        {slug: 'capitals', title: 'Столицы', center: [-40.34, 26.01], zoom: 3, difficult: 'medium'},
        {slug: 'summer_olympic', title: 'Столицы летних Олимпиад', center: [-40.34, 26.01], zoom: 3, difficult: 'easy'},
        {slug: 'hero_cities', title: 'Города-герои СССР', center: [-40.34, 26.01], zoom: 3, difficult: 'easy'},
        {slug: '10billions', title: '10-миллионники', center: [-40.34, 26.01], zoom: 3, difficult: 'medium'},
      ]
    }, {
      title: 'Страны',
      items: [
        {slug: 'usa', title: 'США (лёгкий)', center: [-109.68, 34.80], zoom: 4, difficult: 'medium'},
        {slug: 'usa_hard', title: 'США (сложный)', center: [-109.68, 34.80], zoom: 4, difficult: 'hard'},
        {slug: 'japan', title: 'Япония', center: [139.48, 36.65], zoom: 6, difficult: 'hard'},
        {slug: 'uk', title: 'Великобритания', center: [-3.36, 55.44], zoom: 6, difficult: 'medium'},
        {slug: 'italy', title: 'Италия', center: [11.35, 39.96], zoom: 6, difficult: 'medium'},
        {slug: 'russia_easy', title: 'Россия (лёгкий)', center: [85.78, 60.82], zoom: 4, difficult: 'easy'},
        {slug: 'russia_hard', title: 'Россия (сложный)', center: [85.78, 60.82], zoom: 4, difficult: 'medium'},
      ]
    }]
  },
  nature: {
    title: 'Наша планета',
    text: 'На нашей планете много рек, гор и морей. Некоторые из них огромны как Средиземное море, другие — едва различимы на карте. Сможете ли вы найти наиболее популярные из них?',
    sections: [{
      title: 'Мир',
      items: [
        {slug: 'europe_geo', title: 'Европа', center: [13.00, 48.51], zoom: 4, difficult: 'easy'},
        {slug: 'arctic_ocean', title: 'Моря Арктики', center: [22.00, 75.36], zoom: 4, difficult: 'medium'},
        {slug: 'deserts', title: 'Пустыни', center: [-0.85, 29.24], zoom: 4, difficult: 'medium'},
      ]
    }, {
      title: 'Регионы',
      items: [
        {slug: 'mediterranean', title: 'Средиземное море', center: [15.66, 39.51], zoom: 5, difficult: 'easy'},
        {slug: 'great_lakes', title: 'Великие озёра', center: [-84.40, 45.26], zoom: 6, difficult: 'hard'},
        {slug: 'saasia_geo', title: 'Юго-Восточная Азия', center: [115.33, 9.98], zoom: 5, difficult: 'hard'},
        {slug: 'arabian_geo', title: 'Аравийский полуостров', center: [44.14, 26.28], zoom: 6, difficult: 'medium'},
        {slug: 'aegean_sea', title: 'Эгейское море', center: [25.25, 38.19], zoom: 6, difficult: 'hard'},
        {slug: 'italian_p', title: 'Аппенинский полуостров', center: [12.87, 43.41], zoom: 6, difficult: 'medium'},
      ]
    }]
  }/*,
  space: {
    title: 'Космос',
    text: 'Плейсхолдер для космических объектов',
    sections: [{
      title: 'Луна',
      items: [
        {slug: 'apollo', title: 'Апполоны', center: [0, 0], zoom: 3, theme: 'dark', difficult: 'easy', planet: 'moon'},
        {slug: 'moon_landing', title: 'Мягкая посадка', center: [0, 0], zoom: 3, theme: 'dark', difficult: 'easy', planet: 'moon'},
        {slug: 'moon_mare', title: 'Моря и океаны', center: [0, 0], zoom: 3, theme: 'dark', difficult: 'easy', planet: 'moon'},
        {slug: 'moon_easy', title: 'Лёгкий', center: [0, 0], zoom: 3, theme: 'dark', difficult: 'easy', planet: 'moon'},
        // {slug: 'moon_craters', title: 'Кратеры', center: [0, 0], zoom: 3, theme: 'dark', difficult: 'easy', planet: 'moon'},
      ]
    }, {
      title: 'Марс',
      items: [
        // {slug: 'mars_landing', title: 'Мягкая посадка', center: [0, 0], zoom: 3, theme: 'dark', difficult: 'easy', planet: 'mars'},
        // {slug: 'moon_mare', title: 'Моря и океаны', center: [0, 0], zoom: 3, theme: 'dark', difficult: 'easy', planet: 'moon'},
        // {slug: 'moon_easy', title: 'Лёгкий', center: [0, 0], zoom: 3, theme: 'dark', difficult: 'easy', planet: 'moon'},
      ]
    }]
  }*/
};

export {GAMES};
